// MatnrPartPriceReportPage.jsx
import React from 'react';
import { Button } from 'primereact/button';
import useMatnrPartPriceReport from './hooks/useMatnrPartPriceReport';
import MatnrPartPriceTable from './components/MatnrPartPriceTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportMatnrPartsPriceToExcelQuery } from '../../../api/endpoints/matnrPartsPriceReport';

const extractFileName = (result) => result?.fileName || 'Parça Perakende Fiyat Listesi.xlsx';
const extractData = (result) => result?.fileBase64;
const extractContentType = (result) => result?.contentType;

const MatnrPartPriceReportPage = () => {
    const { th } = useLanguage();
    const { 
        apiData, 
        isLoading, 
        lazyParams, 
        sortField, 
        sortOrder, 
        activeFilters, 
        onPage, 
        onSort, 
        handleFilterChange, 
        initFilters, 
        exportParams,
        isDomestic // isDealer kullanılmadığı için kaldırıldı
    } = useMatnrPartPriceReport();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('matnrPartsPriceReport.title')}</h1>
                <div className="flex gap-2">
                    <Button 
                        icon="pi pi-filter-slash" 
                        className="p-button-outlined p-button-secondary" 
                        onClick={initFilters} 
                        tooltip={th('filter.reset')} 
                        tooltipOptions={{ position: 'left' }} 
                    />
                    <GenericFileExportButton
                        useExportQuery={useLazyExportMatnrPartsPriceToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel="Excel"
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={extractFileName}
                        dataExtractor={extractData}
                        contentTypeExtractor={extractContentType}
                    />
                </div>
            </div>
            <MatnrPartPriceTable
                items={apiData?.items ?? []}
                totalCount={apiData?.totalCount ?? 0}
                loading={isLoading}
                lazyParams={lazyParams}
                onPage={onPage}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
                isDomestic={isDomestic} // isDealer prop'u tablodan kaldırıldığı için buradan da temizlendi
            />
        </div>
    );
};

export default MatnrPartPriceReportPage;